module.exports = __webpack_public_path__ + "static/media/crop-icon.30c63682.svg";